import { render, staticRenderFns } from "./WxQrCode.vue?vue&type=template&id=49dc055f&scoped=true&"
import script from "./WxQrCode.vue?vue&type=script&lang=js&"
export * from "./WxQrCode.vue?vue&type=script&lang=js&"
import style0 from "./WxQrCode.vue?vue&type=style&index=0&id=49dc055f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc055f",
  null
  
)

export default component.exports